module.exports = __webpack_public_path__ + "media/images/icons/outlined/right-circle-9716866acb62b76c0b681e46d6727803.svg";